import FilterForm from "./FilterForm";

export const COLUMNS = [
  {
    Header: "Staff ID",
    accessor: "staff_Id",
    Filter: FilterForm,
  },
  {
    Header: "Employee Name",
    accessor: "employeeName",
    Filter: FilterForm,
  },
  {
    Header: "Employer",
    accessor: "employer",
    Filter: FilterForm,
  },
  {
    Header: "Remittance Date",
    accessor: "remittance_date",
    Filter: FilterForm,
  },
  {
    Header: "Transaction Period",
    accessor: "period",
    Filter: FilterForm,
  },
  {
    Header: "Total Contribution",
    accessor: "total_contribution",
    Filter: FilterForm,
  },
];
